export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14115.92e744d0.jpg";